import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { UiService } from "app/helper-components/UiService";
import { HelperService } from "app/helpers/helper.service";
import { LogoutService } from "app/helpers/logout.service";
import { PostService } from "app/helpers/post.service";
import { UserDataService } from "app/helpers/user-data.service";
import { environment } from "environments/environment";

@Component({
  selector: "app-pin-view",
  templateUrl: "./pin-view.component.html",
  styleUrls: ["./pin-view.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PinViewComponent implements OnInit {
  @ViewChild("input1") input1;
  @ViewChild("input2") input2;
  @ViewChild("input3") input3;
  @ViewChild("input4") input4;
  @ViewChild("input5") input5;
  @ViewChild("input6") input6;

  checkInputFill = true;
  currentFocusedInput: any;
  hasError = false;
  errorMessage: string;
  public pinRegisterConfirm: string;
  pinSubmitConfirm: string;
  private pin: any = "";
  private confPin: string = "";
  sucessMessage: string = this.translate.instant(
    "You have entered successfully"
  );
  failMessage: string = this.translate.instant("You are blocked");
  okayMessage: string = this.translate.instant("okay");
  pin_status: number = 2;
  showContent: boolean = false;
  showContentFull: boolean = true;
  pinEnterCheck: boolean = false;
  parameters: any;
  constructor(
    private translate: TranslateService,
    private _snackBar: MatSnackBar,
    private _userDataService: UserDataService,
    private _logoutService: LogoutService,
    private _matDialog: MatDialogRef<PinViewComponent>,
    private helper: HelperService,
    private postService: PostService,
    private uiService: UiService,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.parameters = data;
  }

  ngOnInit(): void {
    // console.log(this.parameters);

    this.pin_status = this._userDataService.userData.pin_status;
    if (this.pin_status == 1) {
      this.showContent = false;
      this.pinEnterCheck = true;
      this.pinRegisterConfirm = "Please enter your secret number";
      this.pinSubmitConfirm = "Signin";
    } else if (this.pin_status == 2) {
      this.showContent = true;
      this.pinRegisterConfirm = "Please register your secret number";
      this.pinSubmitConfirm = "Submit";
    } else if (this.pin_status == 3) {
      this.showContentFull = false;
    } else {
      this.parameters.verify_callback(1);
      this._matDialog.close();
    }
  }

  click() {
    this._matDialog.close();
  }

  onInputEntry(event) {
    let input = event.target;
    let length = input.value.length;
    let maxLength = input.attributes.maxlength.value;
    if (length == 0) return;

    var target =
      this.currentFocusedInput.target ||
      this.currentFocusedInput.srcElement ||
      this.currentFocusedInput.currentTarget ||
      this.currentFocusedInput.nativeElement;
    var no = parseInt(target.attributes["data-no"].nodeValue);

    switch (no) {
      case 1:
        this.input2.nativeElement.focus();
        this.input2.nativeElement.select();
        break;
      case 2:
        this.input3.nativeElement.focus();
        this.input3.nativeElement.select();
        break;
      case 3:
        this.input4.nativeElement.focus();
        this.input4.nativeElement.select();
        break;
      case 4:
        this.input5.nativeElement.focus();
        this.input5.nativeElement.select();
        break;
      case 5:
        this.input6.nativeElement.focus();
        this.input6.nativeElement.select();
        break;
    }
  }

  onKeypressEvent(event) {
    let pinView = this;
    var key = event.key;
    let pinTotal =
      this.input1.nativeElement.value +
      this.input2.nativeElement.value +
      this.input3.nativeElement.value +
      this.input4.nativeElement.value +
      this.input5.nativeElement.value +
      this.input6.nativeElement.value;
    if (key === "Backspace" || key === "Delete") {
      var target = event.target || event.srcElement || event.currentTarget;
      var no = parseInt(target.attributes["data-no"].nodeValue);

      switch (no) {
        case 2:
          pinView.input1.nativeElement.focus();
          pinView.input1.nativeElement.select();
          break;
        case 3:
          pinView.input2.nativeElement.focus();
          pinView.input2.nativeElement.select();
          break;
        case 4:
          pinView.input3.nativeElement.focus();
          pinView.input3.nativeElement.select();
          break;
        case 5:
          pinView.input4.nativeElement.focus();
          pinView.input4.nativeElement.select();
          break;
        case 6:
          pinView.input5.nativeElement.focus();
          pinView.input5.nativeElement.select();
          break;
      }
    }

    if (
      (key === "Enter" && pinTotal.length == 6) ||
      (key === "Enter" &&
        this.pin == this.confPin &&
        this.pin != "" &&
        this.confPin != "")
    ) {
      this.onPinSubmit();
    }

    this.checkPinEntry();

    if (this.showContent == true) {
      this.pinValidateRegister();
    }
    if (this.pinEnterCheck == true) {
      this.pinValidateEnter();
    }
  }

  pinValidateEnter() {
    let pinTotal =
      this.input1.nativeElement.value +
      this.input2.nativeElement.value +
      this.input3.nativeElement.value +
      this.input4.nativeElement.value +
      this.input5.nativeElement.value +
      this.input6.nativeElement.value;
    if (pinTotal.length == 6) {
      this.checkInputFill = false;
    } else {
      this.checkInputFill = true;
    }
  }

  pinValidateRegister() {
    if (this.pin == this.confPin && this.pin != "" && this.confPin != "") {
      this.checkInputFill = false;
    } else {
      this.checkInputFill = true;
    }

    if (
      this.pin != "" &&
      this.confPin != "" &&
      this.input6.nativeElement.value != ""
    ) {
      if (this.pin != this.confPin) {
        this.checkInputFill = true;
        this.hasError = true;
        this.errorMessage = "Numbers are not matched";
      }
    } else {
      this.hasError = false;
      this.checkInputFill = true;
    }

    if (this.pin.length >= 6 && this.confPin.length == 0) {
      this.input1.nativeElement.value = "";
      this.input2.nativeElement.value = "";
      this.input3.nativeElement.value = "";
      this.input4.nativeElement.value = "";
      this.input5.nativeElement.value = "";
      this.input6.nativeElement.value = "";
      this.input1.nativeElement.focus();
      this.pinRegisterConfirm = "Please Re-enter the pin again";
    }
  }

  focusFunction(elm) {
    this.currentFocusedInput = elm;
  }

  focusOutFunction(elm) {
    this.currentFocusedInput = null;
  }

  checkPinEntry() {
    if (this.pin.length < 6) {
      this.pin =
        this.input1.nativeElement.value +
        this.input2.nativeElement.value +
        this.input3.nativeElement.value +
        this.input4.nativeElement.value +
        this.input5.nativeElement.value +
        this.input6.nativeElement.value;
    } else if (this.pin.length >= 6) {
      this.confPin =
        this.input1.nativeElement.value +
        this.input2.nativeElement.value +
        this.input3.nativeElement.value +
        this.input4.nativeElement.value +
        this.input5.nativeElement.value +
        this.input6.nativeElement.value;
    }
    return this.pin == this.confPin;
  }

  logout() {
    this._logoutService.logout();
  }

  onPinSubmit() {
    this.uiService.showLoading();
    if (this.pin_status == 1) {
      if (this.confPin == "") {
        this.confPin = this.pin;
      } else if (this.confPin != "") {
        this.confPin = this.confPin;
      }
      const formData = new FormData();
      formData.append(this.helper.getMangledName("verifyPin"), "1");
      formData.append("pin", this.confPin);

      this.postService
        .post(environment.API_LOGIN + "?elc=7", formData)
        .subscribe((val) => {
          this.uiService.hideLoading();
          if (val.status_code == 1) {
            this.parameters.verify_callback(1);
            this._snackBar.open(
              this.translate.instant("You have entered successfully"),
              this.okayMessage,
              {
                data: this.sucessMessage,
                duration: 1500,
                verticalPosition: "top",
                horizontalPosition: "center",
                panelClass: ["success-show", "green-600"],
              }
            );
            this._matDialog.close();
          } else if (val.status_code == 2) {
            this.checkInputFill = true;
            this.hasError = true;
            this.errorMessage =
              this.translate.instant("You have entered wrong pin, ") +
              val.rem_attempt +
              this.translate.instant(" attempts remaining");
            this.pin = "";
            this.confPin = "";
            this.input1.nativeElement.value = "";
            this.input2.nativeElement.value = "";
            this.input3.nativeElement.value = "";
            this.input4.nativeElement.value = "";
            this.input5.nativeElement.value = "";
            this.input6.nativeElement.value = "";
            this.input1.nativeElement.focus();
          } else {
            this.checkInputFill = true;
            this.showContentFull = false;
          }
        });
    }

    if (this.pin_status == 2) {
      const formData = new FormData();
      formData.append(this.helper.getMangledName("createPin"), "1");
      formData.append("pin", this.pin);

      this.postService
        .post(environment.API_LOGIN + "?elc=7", formData)
        .subscribe((val) => {
          this.uiService.hideLoading();
          if (val.status_code == 1) {
            this._snackBar.open(
              this.translate.instant("Pin registered successfully"),
              this.okayMessage,
              {
                data: this.sucessMessage,
                duration: 1500,
                verticalPosition: "top",
                horizontalPosition: "center",
                panelClass: ["success-show", "green-600"],
              }
            );
            this._matDialog.close();
            location.reload();
          } else if (val.status_code == -2) {
            this.checkInputFill = true;
            this.hasError = true;
            this.errorMessage = "You have entered weak pin, try again";
            this.input1.nativeElement.value = "";
            this.input2.nativeElement.value = "";
            this.input3.nativeElement.value = "";
            this.input4.nativeElement.value = "";
            this.input5.nativeElement.value = "";
            this.input6.nativeElement.value = "";
            this.input1.nativeElement.focus();
            this.pinRegisterConfirm = "Please enter your secret number";
            this.confPin = "";
            this.pin = "";
          } else {
            this.checkInputFill = true;
            this.hasError = true;
            this.errorMessage = "Pin registration failed, please try again";
          }
        });
    }
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
